import { utils } from '../../utils';

export const FEATURE_TYPE =
{
  FIELD: 0,
  ROAD: 1,
  CITY: 2,
  CLOISTER: 3,

  CITY_SHIELD: 4
};

export const pixiGameUtils =
{
  featureTypeValueToString: ( featureTypeValue, toLower = false ) =>
  {
    let featureTypeString = null;

    switch( featureTypeValue )
    {
      case FEATURE_TYPE.ROAD:
        featureTypeString = "Road";
        break;
      case FEATURE_TYPE.CITY:
        featureTypeString = "City";
        break;
      case FEATURE_TYPE.FIELD:
        featureTypeString = "Field";
        break;
      case FEATURE_TYPE.CLOISTER:
        featureTypeString = "Cloister";
        break;
      default:
        console.log( "Unknown feature value : ", featureTypeValue );
        featureTypeString = "Unknown";
        break;
    }

    if( toLower )
    {
      featureTypeString = featureTypeString.toLowerCase();
    }
    return featureTypeString;
  },

  featureTypeValueToImgURL_32x32( featureTypeValue )
  {
    let featureTypeString = pixiGameUtils.featureTypeValueToString( featureTypeValue, true );
    return `./ui/feature-icon-${featureTypeString}-32.png`;
  },

  featureTypeValueToImgURL_128x128( featureTypeValue )
  {
    let featureTypeString = pixiGameUtils.featureTypeValueToString( featureTypeValue, true );
    return `./ui/feature-icon-${featureTypeString}-128.png`;
  },

  featureTypeValueToImgURL_512x512( featureTypeValue )
  {
    let featureTypeString = pixiGameUtils.featureTypeValueToString( featureTypeValue, true );
    return `./ui/feature-icon-${featureTypeString}-512.png`;
  },

  getBotPlayerSprite( colourID )
  {
    return "./ui/Meeple - UI Circle - BOT Opponent - " + utils.capitalizeFirstLetter( colourID ) + ".png";
  },

  getHumanPlayerSprite( colourID )
  {
    return "./ui/Meeple - UI Circle - Player - " + utils.capitalizeFirstLetter( colourID ) + ".png";
  },

  getHumanOpponentSprite( colourID )
  {
    return "./ui/Meeple - UI Circle - Opponent - " + utils.capitalizeFirstLetter( colourID ) + ".png"
  },

  getPlayerIconSprite( playerData )
  {
    if( playerData.isBot )
    {
      return pixiGameUtils.getBotPlayerSprite( playerData.colourID );
    }
    else if( playerData.socketID )
    {
      return playerData.isClient
        ? pixiGameUtils.getHumanPlayerSprite( playerData.colourID )
        : pixiGameUtils.getHumanOpponentSprite( playerData.colourID );
    }
    else
    {
      return playerData.isClient
        ? pixiGameUtils.getHumanPlayerSprite( playerData.colourID )
        : pixiGameUtils.getHumanOpponentSprite( playerData.colourID );
    }
  }

};
